import {
    PASSWORD_RESET_REQUEST_REQUEST,
    PASSWORD_RESET_REQUEST_SUCCESS,
    PASSWORD_RESET_REQUEST_FAIL,
    PASSWORD_RESET_REQUEST_RESET,
    PASSWORD_RESET_CONFIRM_REQUEST,
    PASSWORD_RESET_CONFIRM_SUCCESS,
    PASSWORD_RESET_CONFIRM_FAIL,
    PASSWORD_RESET_CONFIRM_RESET,
} from '../constants/passwordResetConstants'

export const passwordResetRequestReducer = (state = {}, action) => {
    switch (action.type) {
        case PASSWORD_RESET_REQUEST_REQUEST:
            return { loading: true }

        case PASSWORD_RESET_REQUEST_SUCCESS:
            return { loading: false, success: true, message: action.payload.detail }

        case PASSWORD_RESET_REQUEST_FAIL:
            return { loading: false, error: action.payload }

        case PASSWORD_RESET_REQUEST_RESET:
            return {}

        default:
            return state
    }
}

export const passwordResetConfirmReducer = (state = {}, action) => {
    switch (action.type) {
        case PASSWORD_RESET_CONFIRM_REQUEST:
            return { loading: true }

        case PASSWORD_RESET_CONFIRM_SUCCESS:
            return { loading: false, success: true, message: action.payload.detail }

        case PASSWORD_RESET_CONFIRM_FAIL:
            return { loading: false, error: action.payload }

        case PASSWORD_RESET_CONFIRM_RESET:
            return {}

        default:
            return state
    }
}
